import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {TheRave} from "../../TheRave";
import {TimelineLite} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class WinsHighLight extends ReelStopPresentationController {

    private _tl: TimelineLite;

    constructor() {
        super("WinsHighLight");
    }

    protected async onReelBounce(data: IReelStateEventData): Promise<any> {
        const noWin: boolean = TheRave.model.parsedGameData.singleWin === 0,
            wins: boolean[][] = TheRave.model.parsedGameData.potentialWinPos;
        if (data.reelId < 2 || noWin || data.reelId>4) {
            await Promise.resolve();
            return;
        }

        if(wins[data.reelId].indexOf(true) < 0){
            await Promise.resolve();
            return;
        }
        const tl: TimelineLite = new TimelineLite({paused: true});
        wins.forEach((wins: boolean[], reel: number) => {
            if (reel <= data.reelId) {
                wins.forEach((hasWin: boolean, i: number) => {
                    if (hasWin) {
                        tl.add(TheRave.reels[reel].getSymbol(i, false).playHighLight(TheRave.apiPlugin.settings.get(APISetting.FAST_SPIN)), 0);
                    }
                })
            }
        });
        tl.to(this, {duration: 0.1});
        tl.play(0);
        this._tl = tl;
        await Promise.resolve(this._tl);
        return;
    }

    public skip() {
        if (this._tl) {
            this._tl.timeScale(2);
        }
    }
}